import React, { useMemo } from "react";
import { useSelector } from "store";

import { TodayEventMorphCard } from "./TodayEventMorphCard";

import type { FC } from "react";

export const TodayEvent: FC = () => {
  const myTickets = useSelector((state) => state.ticket.myTickets);

  const ticketInSessionEvent = useMemo(() => {
    if (myTickets === null || myTickets.length === 0) {
      return [];
    }

    const currentDatetime = Date.now();

    return myTickets
      .filter((el) => {
        // イベントが終了している場合は表示しない
        if (el.event.isClosed) return false;
        // myTicketsには、チケットがないイベントも含まれている（Goodsなど）ため、チケットがないイベントは表示しない
        if (el.tickets.length === 0) return false;
        // event.partsがない場合は表示しない
        if (el.event.parts.length === 0) return false;

        const { eventStartTime } = el.event;
        if (eventStartTime === undefined) return false;

        /**
         * @description
         * イベントが開催中のものを抽出する処理
         *
         * イベントの開催日時は、event.partsに格納されている。
         * イベントの開催中の判定は、event.parts.openTime < 現在時刻 < event.parts.openTimeの23:59:59 で行なっている。
         * イベント終了の判定をevent.parts.openTimeの23:59:59で行なっている理由は、DBにイベント終了日時が格納されていないため。
         * event.partsは配列なので、filterした結果が空の場合は、開催中のイベントがないと判定する。
         */
        const inSessionEvent = el.event.parts.filter((part) => {
          const eventOpenDate = new Date(part.openTime.seconds * 1000);
          const eventOpenDatetime = new Date(
            eventOpenDate.getFullYear(),
            eventOpenDate.getMonth(),
            eventOpenDate.getDate(),
            0,
            0,
            0
          ).getTime();
          const eventEndDatetime = new Date(
            eventOpenDate.getFullYear(),
            eventOpenDate.getMonth(),
            eventOpenDate.getDate(),
            23,
            59,
            59
          ).getTime();

          return (
            eventOpenDatetime < currentDatetime &&
            currentDatetime < eventEndDatetime
          );
        });

        return inSessionEvent.length > 0;
      })
      .sort((a, b) => {
        const aOpen = a.event.parts[0]?.openTime.seconds ?? 0;
        const bOpen = b.event.parts[0]?.openTime.seconds ?? 0;
        return aOpen - bOpen;
      });
  }, [myTickets]);

  if (ticketInSessionEvent.length === 0) {
    return null;
  }

  const todayEvents = ticketInSessionEvent.map((el) => el.event);
  return <TodayEventMorphCard events={todayEvents} />;
};
